import * as React from 'react';
import { createRendererWithUniDriver } from '../../test/utils';
import { radioButtonGroupDriverFactory } from './RadioButtonGroup.driver';
import { RadioButtonGroup } from '.';
import { RadioButton } from '../RadioButton';

const noop = () => {};
const TestComp: React.FunctionComponent<any> = ({
  initialValue,
  onChange,
  ...props
}) => {
  const [value, setValue] = React.useState(initialValue);
  const onChangeWrapper = (v) => {
    setValue(v);
    onChange?.(v);
  };

  return (
    <RadioButtonGroup value={value} onChange={onChangeWrapper} {...props}>
      <RadioButton
        value="group1"
        data-hook="radio"
        onChange={noop}
        label="RadioButton 1"
      />
      <RadioButton
        value="group2"
        data-hook="radio"
        onChange={noop}
        label="RadioButton 2"
      />
      <RadioButton
        value="group3"
        data-hook="radio"
        onChange={noop}
        label="RadioButton 3"
      />
    </RadioButtonGroup>
  );
};

describe('RadioButtonGroup', () => {
  const createDriver = createRendererWithUniDriver(
    radioButtonGroupDriverFactory,
  );

  it('should render', async () => {
    const { driver } = createDriver(
      <RadioButtonGroup onChange={() => {}} name="name" />,
    );
    expect(await driver.exists()).toBe(true);
  });

  it('should set lang to root', async () => {
    const lang = 'he';
    const { driver } = createDriver(
      <RadioButtonGroup onChange={() => {}} name="name" lang={lang} />,
    );

    expect(await driver.getLang()).toBe(lang);
  });

  it('should render with children', async () => {
    const { driver } = createDriver(<TestComp />);

    expect(await driver.exists()).toBe(true);
    expect(await driver.getItemsCount('radio')).toBe(3);
  });

  it('should trigger onChange prop when value changes', async () => {
    const onChange = jest.fn();
    const { driver } = createDriver(
      <TestComp initialValue="group1" onChange={onChange} />,
    );

    await driver.clickItemInput(1);
    expect(onChange).toHaveBeenCalledTimes(1);
    expect(onChange).toHaveBeenCalledWith('group2');
  });

  it('should not trigger onChange prop when value does not change', async () => {
    const onChange = jest.fn();
    const { driver } = createDriver(
      <TestComp initialValue="group1" onChange={onChange} />,
    );

    await driver.clickItemInput(0);
    expect(onChange).not.toHaveBeenCalled();
  });

  it('should forward name prop to radio buttons', async () => {
    const { driver } = createDriver(<TestComp name="name" />);
    const element = (await driver.element()) as HTMLElement;
    const namedRadios = element.querySelectorAll('input[name="name"]');
    expect(namedRadios.length).toBe(3);
  });
});
